import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { isWarehouseTutorialActive } from "@me-team/common/src/components/Joyride/WarehouseTutorial/joyrideStepHelpers";

interface ButtonProps {
    text: string;
    onClick: () => void;
    variant: string;
    className?: string;
    type?: "button" | "submit" | "reset";
    disabled?: boolean;
}

interface AddEditModalProps {
    isModalOpened: boolean;
    setIsModalOpened: (isOpened: boolean) => void;
    title: string;
    children: React.ReactNode;
    contentClassName?: string;
    modalBodyClass?: string;
    dialogClassName?: string;
    centered?: boolean;
    textAlign?: "start" | "center" | "end";
    size?: "lg" | "xl" | "sm";
    dataTour?: string;
}

const AddEditModal: React.FC<AddEditModalProps> = ({
    isModalOpened,
    setIsModalOpened,
    children,
    title,
    contentClassName,
    modalBodyClass,
    dialogClassName,
    textAlign = "center",
    size = "lg",
    dataTour,
    centered = true,
}) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const tutorialActive = isWarehouseTutorialActive();

    const handleModalClose = () => {
        setIsModalOpened(false);
    };

    useEffect(() => {
        if (contentRef.current && dataTour) {
            contentRef.current.setAttribute("data-tour", dataTour);
        }
    }, [dataTour, isModalOpened]);

    return (
        <Modal
            show={isModalOpened}
            size={size}
            onHide={handleModalClose}
            centered={centered}
            contentClassName={contentClassName}
            dialogClassName={dialogClassName ? dialogClassName : ""}
            onEntered={() => {
                tutorialActive && requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
            }}
        >
            <div ref={contentRef}>
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="h5">{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className={`text-${textAlign ?? "center"} ${modalBodyClass ? modalBodyClass : ""}`}>
                    {children}
                </Modal.Body>
            </div>
        </Modal>
    );
};

export default AddEditModal;
